module.exports = __webpack_public_path__ + "img/ks.6b3be901.png";